export enum ErrorLocation {
  NONE = 0,
  BLOCK_GPS = 1,
  NOT_AVAILABLE = 2,
  EMPTY_ADDRESS = 3,
}
